module.exports = __webpack_public_path__ + "img/inner-3.ec7b7fa2.png";